import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { bedDislocationByVisitIdApi } from "../../../services/consultation.service";
import { toast } from "react-toastify";

const BedDislocationModal = ({ open, onClose, id }) => {
  const [loading, setLoading] = useState(false);
  const initialState = {
    dischargeDate: dayjs(),
    dischargeReason: "",
    followUpDate: null,
  };
  const [formData, setFormData] = useState(initialState);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };
  const handleDateChange = (name, newValue) => {
    setFormData((prevValue) => ({
      ...prevValue,
      [name]: newValue ? newValue.toISOString() : null,
    }));
  };
  const submitHandler = async (e) => {
    e.preventDefault();
    console.log(formData, "form");
    setLoading(true);
    const response = await bedDislocationByVisitIdApi(id, formData);
    setLoading(false);
    if (response?.code === 200 || response?.code === 201) {
      toast.success("Bed Dislocation saved successfully");
      onClose();
      setFormData(initialState);
    } else {
      toast.error(response?.message || "Some error occurred!");
    }
  };
  useEffect(() => {
    setFormData(initialState);
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: "70vw",
          bgcolor: "#E5F4FF",
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box component={"form"} onSubmit={submitHandler}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: "20px",
            }}
          >
            <Typography variant="h6" sx={{ color: "#5D6A82" }}>
              Discharge Details
            </Typography>
            <Close
              onClick={onClose}
              sx={{ cursor: "pointer", color: "#5D6A82" }}
            />
          </Box>

          <Grid
            container
            spacing={3}
            sx={{
              mb: "40px",
            }}
          >
            <Grid item xs={12} sm={6} md={4}>
              <DatePicker
                label="Discharge Date"
                name="dischargeDate"
                value={
                  formData?.dischargeDate ? dayjs(formData.dischargeDate) : null
                }
                onChange={(newValue) =>
                  handleDateChange("dischargeDate", newValue)
                }
                slotProps={{ textField: { fullWidth: true, required: true } }}
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="dischargeReason"
                value={formData?.dischargeReason || ""}
                onChange={handleChange}
                label="Discharge Reason"
                required
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <DatePicker
                label="Follow Up Date"
                name="followUpDate"
                value={
                  formData.followUpDate ? dayjs(formData.followUpDate) : null
                }
                onChange={(newValue) =>
                  handleDateChange("followUpDate", newValue)
                }
                slotProps={{ textField: { fullWidth: true, required: true } }}
                sx={{ background: "white" }}
              />
            </Grid>
          </Grid>

          {/* submit button */}
          <Box sx={{ my: "20px", textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{ width: "150px", textTransform: "none" }}
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress size={"20px"} /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BedDislocationModal;
